import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { FullscreenCommentTemplate } from './variants/FullscreenComment'
import { FullscreenSlideTemplate } from './variants/FullscreenSlide'

const commentVariant = {
  ...productRowVariantForPath('fullscreen', 2),
  Template: FullscreenCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('fullscreen', 3),
  Template: FullscreenSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('fullscreen')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
